<svg width="12" height="9" viewBox="0 0 12 9" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M11.3332 0.667969L3.99984 8.0013L0.666504 4.66797" stroke="#04051B" stroke-width="1.33333" stroke-linecap="round" stroke-linejoin="round"/>
</svg>
